import { z } from 'zod'

import {
  abstractComponent,
  COMPONENT_TYPES,
} from '@customTypes/cloudmix/sessions/components/base'
import { audioVideoPadSchema } from '../../pads'

export enum PlayerState {
  Stopped = 'stopped',
  Playing = 'playing',
  Paused = 'paused',
  ReachedEnd = 'reached_end',
}

export const playerUriSchema = z.string().trim().url()

export const basePlayerSourceComponentSchema = abstractComponent.extend({
  type: z
    .literal(COMPONENT_TYPES.playerSource)
    .default(COMPONENT_TYPES.playerSource),
  output: audioVideoPadSchema,
  uri: playerUriSchema,
  recordingEnabled: z.boolean().default(false).nullish(),
  loop: z.boolean().default(false).nullish(),
  playbackRange: z
    .object({
      in: z.number().nullish(),
      out: z.number().nullish(),
    })
    .nullable()
    .default(null),
})
export type BasePlayerSourceComponent = z.infer<
  typeof basePlayerSourceComponentSchema
>

export const projectPlayerSourceComponentSchema = basePlayerSourceComponentSchema
export type ProjectPlayerSourceComponent = z.infer<
  typeof projectPlayerSourceComponentSchema
>

export const playerSourceComponentSchema =
  basePlayerSourceComponentSchema.extend({
    duration: z.number().nullish(),
    position: z.number().nullish(),
    positionUpdatesPerSecond: z.number().nullish(),
    playerState: z
      .nativeEnum(PlayerState)
      .default(PlayerState.Paused)
      .nullish(),
  })
